module.exports = __webpack_public_path__ + "img/cake-15.8d0e1f29.svg";